export default "__VITE_ASSET__2b05254b__"